import Card from "components/card";
import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Listitem } from "../../../Redux/Items/action";
import { itemLedger, TransactionReport } from "../../../Redux/Report/action";

const ItemLedger = () => {
  const dispatch = useDispatch();
  const [SelectItem, setSelectItem] = useState("265");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [checked, setChecked] = useState(false);

  const TempleID = JSON.parse(localStorage.getItem("Sopanam_TempleId"));
  const ItemData = useSelector((state) => state.Items.ListItemData);

  const fromdate = new Date(fromDate);
  const itemLedgerlist = useSelector((state) => state?.Report?.itemLedger);
  fromdate.setUTCHours(0);
  fromdate.setUTCMinutes(0);
  fromdate.setUTCSeconds(0);

  const formattedfromDate =
    fromdate.toISOString().slice(0, 10) + " 00:00:00.000";
  // console.log(format(fromdate,"yyyy-dd-MM"),"formattedfromDate");
  const todate = new Date(toDate);

  todate.setUTCHours(0);
  todate.setUTCMinutes(0);
  todate.setUTCSeconds(0);

  useEffect(() => {
    dispatch(
      Listitem({
        TempleId: TempleID,
      })
    );
  }, []);
  const formattedtoDate = todate.toISOString().slice(0, 10) + " 00:00:00.000";
  useEffect(() => {
    dispatch(
      itemLedger({
        ItemId: SelectItem,
        TempleId: TempleID,
        FromDate: formattedfromDate,
        ToDate: formattedtoDate,
      })
    );
  }, [formattedfromDate, formattedtoDate, SelectItem]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    // Pad single digits with leading zeros
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${formattedDay}/${formattedMonth}/${year}`;
  };

  console.log(itemLedgerlist,"itemLedgerlist");
  return (
    <div>
      <Card extra={"w-full h-full p-4 h-[90vh]"}>
        <div className="relative flex items-center justify-between">
          <div className="pb-5 text-xl font-bold text-navy-700 dark:text-white">
            Item Ledger
          </div>
        </div>
        <div className="relative flex">
          <div className="mt-4 pb-5">
            <DatePicker
              selected={fromDate}
              onChange={(date) => setFromDate(date)}
              placeholderText="From Date"
              dateFormat="dd/MM/yyyy"
              selectsStart
              className="mr-2"
            />
          </div>
          <div className="mt-4">
            <DatePicker
              selected={toDate}
              onChange={(date) => setToDate(date)}
              placeholderText="To Date"
              selectsEnd
              dateFormat="dd/MM/yyyy"
              className="mr-2"
            />
          </div>
          <div className="mr-6 pb-5 text-xl font-bold text-navy-700 dark:text-white">
            <select
              className="block w-full rounded-lg border border-gray-700 border-green-500 bg-gray-50 p-2.5 text-sm text-gray-900 focus:ring-blue-500 dark:border dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500"
              id="party"
              value={SelectItem}
              onChange={(e) => setSelectItem(e.target.value)}
              style={{ maxHeight: "150px", overflowY: "auto", width: "240px" }}
            >
              <option value="">Select Item</option>
              {Array.isArray(ItemData) &&
                ItemData.length > 0 &&
                ItemData.map((item) => (
                  <option key={item.Id} value={item.Id}>
                    {item.Name}
                  </option>
                ))}
            </select>
          </div>
          <div className="flex w-full justify-center">
            <div className="flex w-full flex-row gap-2 text-[12px]">
              <b>Opening Stock :</b>
              <b>{itemLedgerlist?.CurrentStock?Number(itemLedgerlist?.OpeningStock).toFixed(3):Number("0.000").toFixed(3)}</b>
            </div>
            <div className="flex w-full flex-row gap-2 text-[12px]">
              <b>Current Stock :</b>
              <b>{itemLedgerlist?.CurrentStock?Number(itemLedgerlist?.CurrentStock).toFixed(3):Number("0.000").toFixed(3)}</b>
            </div>
          </div>
        </div>

        <div className="h-full md:h-[75vh] md:overflow-y-auto ">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <div className="max-h-[73vh] overflow-y-auto">
              <table className="w-full text-left text-sm text-gray-500 dark:text-gray-400 rtl:text-right">
                <thead className="sticky top-0 z-1 bg-gray-50 text-xs uppercase text-gray-700 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th
                      colSpan={5}
                      className="bg-gray-200 px-6 py-3 text-center"
                    >
                      Purchase
                    </th>
                    <th scope="col" className="px-6 py-3"></th>
                    <th
                      colSpan={5}
                      className="bg-gray-200 px-6 py-3 text-center"
                    >
                      Sale
                    </th>
                  </tr>
                  <tr>
                    <th scope="col" className="px-6 py-3">
                      SL NO
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Bill Date
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Bill No
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Party Name
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Quantity
                    </th>
                    <th scope="col" className="px-6 py-3"></th>
                    <th scope="col" className="px-6 py-3">
                      SL NO
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Bill Date
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Bill No
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Party Name
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Quantity
                    </th>
                  </tr>
                </thead>
                <tbody>
                {(() => {
    const purchaseList = itemLedgerlist?.Purchases || [];
    const saleList = itemLedgerlist?.Sales || [];

    const hasPurchases = purchaseList.length > 0;
    const hasSales = saleList.length > 0;
  
    // If both lists are empty
    if (!hasPurchases && !hasSales) {
      return (
        <tr>
          <td colSpan="11" className="px-6 py-4 text-center text-gray-500">
            No Purchases or Sales
          </td>
        </tr>
      );
    }

    // If only purchases are empty
  if (!hasPurchases && hasSales) {
    return saleList.map((sale, index) => {
      const formattedSaleDate = sale?.BillDate ? formatDate(sale.BillDate) : "";

      return (
        <tr key={index} className={`border-b ${index % 2 === 0 ? "even:bg-gray-50 dark:bg-gray-800" : "odd:bg-white dark:odd:bg-gray-900"}`}>
          <td className="px-6 py-4 text-gray-900 text-center"  colSpan={5}>
            {index === 0 ? "No Purchases" : ""}
          </td>
          <td className="px-6 py-4 text-gray-900"></td>
          <td className="px-6 py-4 text-gray-900">{index + 1}</td>
          <td className="px-6 py-4 text-gray-900">{formattedSaleDate}</td>
          <td className="px-6 py-4 text-gray-900">{sale.BillNo}</td>
          <td className="px-6 py-4 text-gray-900">{sale.PartyName}</td>
          <td className="px-6 py-4 text-gray-900">{sale?.IssuedQuantity?.toFixed(3)}</td>
        </tr>
      );
    });
  }

   // If only sales are empty
   if (hasPurchases && !hasSales) {
    return purchaseList.map((purchase, index) => {
      const formattedPurchaseDate = purchase?.BillDate ? formatDate(purchase.BillDate) : "";

      return (
        <tr key={index} className={`border-b ${index % 2 === 0 ? "even:bg-gray-50 dark:bg-gray-800" : "odd:bg-white dark:odd:bg-gray-900"}`}>
          <td className="px-6 py-4 text-gray-900">{index + 1}</td>
          <td className="px-6 py-4 text-gray-900">{formattedPurchaseDate}</td>
          <td className="px-6 py-4 text-gray-900">{purchase.BillNo}</td>
          <td className="px-6 py-4 text-gray-900">{purchase.PartyName}</td>
          <td className="px-6 py-4 text-gray-900">{purchase?.PurchasedQuantity?.toFixed(3)}</td>
          <td className="px-6 py-4 text-gray-900"></td>
          <td className="px-6 py-4 text-gray-900 text-center" colSpan={5}>
            {index === 0 ? "No Sales" : ""}
          </td>
        </tr>
      );
    });
  }
    const maxLength = Math.max(purchaseList.length, saleList.length);

    return [...Array(maxLength)].map((_, index) => {
      const purchase = purchaseList[index] || {};
      const sale = saleList[index] || {};
                      const purchaseDate = purchase.BillDate;
                      const saleDate = sale.BillDate;
                      const formattedPurchaseDate = formatDate(purchaseDate);
                      const formattedSaleDate = formatDate(saleDate);
                      return (
                        <tr
                          key={index}
                          className={`border-b ${
                            index % 2 === 0
                              ? "even:bg-gray-50 dark:bg-gray-800"
                              : "odd:bg-white"
                          } ${
                            index % 2 === 0
                              ? "even:bg-gray-800 dark:bg-gray-800"
                              : "odd:bg-gray-900"
                          }`}
                        >
                          <td className="px-6 py-4 text-gray-900">
                            {index + 1}
                          </td>
                          <td className="px-6 py-4 text-gray-900">
                            
                            {purchase.BillDate?formattedPurchaseDate:""}
                          </td>
                          <td className="px-6 py-4 text-gray-900">
                          {purchase.BillNo}
                          </td>
                          <td className="px-6 py-4 text-gray-900">
                            {purchase.PartyName}
                          </td>
                          <td className="px-6 py-4 text-gray-900">
                            {purchase?.PurchasedQuantity?.toFixed(3)}
                          </td>
                          <td className="px-6 py-4 text-gray-900">
                           
                          </td>
                          <td className="px-6 py-4 text-gray-900">
                          {index + 1}
                          </td>
                          <td className="px-6 py-4 text-gray-900">
                            {sale.BillDate?formattedSaleDate:""}
                          </td>
                          <td className="px-6 py-4 text-gray-900">
                          {sale.BillNo}
                          </td>
                          <td className="px-6 py-4 text-gray-900">
                            {sale.PartyName}
                          </td>
                          <td className="px-6 py-4 text-gray-900">
                            {sale?.IssuedQuantity?.toFixed(3)}
                          </td>
                        </tr>
                      );
                    });
                    })()}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ItemLedger;
